import { useEffect, useRef, useState } from 'react';

const SpeakersHeader = () => {
  const [isVisible, setIsVisible] = useState(false);
  const headerRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setIsVisible(true);
        }
      },
      { threshold: 0.2 }
    );

    if (headerRef.current) {
      observer.observe(headerRef.current);
    }

    return () => observer.disconnect();
  }, []);

  return (
    <section className="pt-32 pb-16 bg-gradient-to-br from-primary via-primary-dark to-primary-dark relative overflow-hidden">
      <div className="absolute inset-0 opacity-10">
        <div className="absolute top-0 right-0 w-96 h-96 bg-accent rounded-full blur-3xl"></div>
        <div className="absolute bottom-0 left-0 w-96 h-96 bg-secondary rounded-full blur-3xl"></div>
      </div>
      <div ref={headerRef} className="max-w-[1400px] mx-auto px-6 relative z-10 text-center">
        <div 
          className={`inline-flex items-center space-x-2 px-4 py-2 bg-white/10 rounded-full mb-6 transition-all duration-700 ${
            isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-4'
          }`}
        >
          <i className="ri-mic-line text-accent"></i>
          <span className="text-accent font-semibold text-sm tracking-wide">Bilimsel Program</span>
        </div>
        <h1 
          className={`font-display text-5xl lg:text-6xl font-bold text-white mb-6 transition-all duration-700 delay-150 ${
            isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-4'
          }`}
        >
          Konuşmacılar & Oturumlar
        </h1>
        <p 
          className={`text-white/80 text-lg max-w-2xl mx-auto leading-relaxed transition-all duration-700 delay-300 ${
            isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-4'
          }`}
        >
          Genç Diş Hekimliği Derneği 2. İstanbul Kongresi'nde yer alan teorik ve pratik oturumların ayrıntılı programı.
        </p>
      </div>
    </section>
  );
};

export default SpeakersHeader;